import consumer from "./consumer"
import { buildActivityBidHTML, buildCommentHTML, buildAuctionEndedHTML } from "../utils/auction_channel_helpers"

// AuctionChannel: Subscribe to real-time auction updates
// This creates a subscription when an auction page is loaded

document.addEventListener('DOMContentLoaded', () => {
  const auctionContainer = document.querySelector('[data-auction-id]')
  if (!auctionContainer) return

  const auctionId = auctionContainer.dataset.auctionId

  consumer.subscriptions.create(
    { channel: "AuctionChannel", auction_id: auctionId },
    {
      connected() {
        console.log(`Connected to auction ${auctionId}`)
      },

      disconnected() {
        console.log(`Disconnected from auction ${auctionId}`)
      },

      received(data) {
        switch (data.type) {
          case 'bid_update':
            this.handleBidUpdate(data)
            break
          case 'time_update':
            this.handleTimeUpdate(data)
            break
          case 'comment_update':
            this.handleCommentUpdate(data)
            break
          case 'auction_ended':
            this.handleAuctionEnded(data)
            break
        }
      },

      handleBidUpdate(data) {
        // Update current bid display
        const bidElement = document.querySelector('[data-current-bid]')
        if (bidElement) {
          bidElement.textContent = data.bid.formatted_amount
        }

        // Update last bid time indicator
        const lastBidTimeEl = document.querySelector('[data-last-bid-time]')
        if (lastBidTimeEl) {
          lastBidTimeEl.textContent = '↑ Hace menos de 1 minuto'
        } else if (bidElement) {
          // First bid: insert the indicator after the price
          const indicator = document.createElement('span')
          indicator.className = 'auction-detail__last-bid-time'
          indicator.dataset.lastBidTime = ''
          indicator.textContent = '↑ Hace menos de 1 minuto'
          bidElement.insertAdjacentElement('afterend', indicator)
        }

        // Update bid count
        const bidCountElement = document.querySelector('[data-bid-count]')
        if (bidCountElement) {
          bidCountElement.textContent = data.auction.bid_count
        }

        // Update minimum bid input
        const minBidInput = document.querySelector('[data-minimum-bid]')
        if (minBidInput) {
          minBidInput.min = data.auction.minimum_bid
          minBidInput.placeholder = `Min: $${data.auction.minimum_bid}`
        }

        // Add bid to activity feed
        const activityFeed = document.querySelector('[data-activity-feed]')
        if (activityFeed) {
          // Remove empty state message if present
          const emptyState = activityFeed.querySelector('.text-muted.text-center')
          if (emptyState) emptyState.remove()

          const bidHTML = buildActivityBidHTML(data.bid)
          activityFeed.insertAdjacentHTML('afterbegin', bidHTML)
        }

        // Dispatch custom event for other components
        document.dispatchEvent(new CustomEvent('auction:bid-update', { detail: data }))
      },

      handleTimeUpdate(data) {
        // Update countdown timer
        const timerElement = document.querySelector('[data-auction-timer]')
        if (timerElement) {
          timerElement.dataset.endsAt = data.ends_at
          timerElement.dataset.timeRemaining = data.time_remaining
        }

        // Show sniping protection indicator if active
        const snipingIndicator = document.querySelector('[data-sniping-indicator]')
        if (snipingIndicator) {
          snipingIndicator.classList.toggle('active', data.sniping_protection_active)
        }

        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('auction:time-update', { detail: data }))
      },

      handleCommentUpdate(data) {
        const activityFeed = document.querySelector('[data-activity-feed]')
        if (!activityFeed) return

        // Remove empty state message if present
        const emptyState = activityFeed.querySelector('.text-muted.text-center')
        if (emptyState) emptyState.remove()

        // Create new comment element
        const commentElement = document.createElement('div')
        commentElement.id = `comment-${data.comment.id}`
        commentElement.className = `comment ${data.comment.from_seller ? 'from-seller' : ''}`
        commentElement.innerHTML = buildCommentHTML(data.comment)

        // Add to appropriate location (reply or top-level)
        if (data.comment.parent_id) {
          const parentComment = document.querySelector(`#comment-${data.comment.parent_id}`)
          const repliesContainer = parentComment?.querySelector('.replies') || activityFeed
          repliesContainer.appendChild(commentElement)
        } else {
          activityFeed.prepend(commentElement)
        }

        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('auction:comment-update', { detail: data }))
      },

      handleAuctionEnded(data) {
        // Update UI to show auction has ended
        const auctionStatus = document.querySelector('[data-auction-status]')
        if (auctionStatus) {
          auctionStatus.textContent = data.reserve_met ? 'Sold' : 'Reserve Not Met'
          auctionStatus.className = `auction-status ${data.status}`
        }

        // Disable bid form
        const bidForm = document.querySelector('[data-bid-form]')
        if (bidForm) {
          bidForm.innerHTML = buildAuctionEndedHTML(data)
        }

        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('auction:ended', { detail: data }))
      }
    }
  )
})
